(function (global) {
  function createBrandedPdf(title, subtitle) {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();

    doc.setFontSize(20);
    doc.setTextColor(59, 130, 246);
    doc.text(title, 105, 20, { align: 'center' });

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text('Fire-Calc.com', 105, 30, { align: 'center' });

    if (subtitle) {
      doc.setFontSize(10);
      doc.setTextColor(71, 85, 105);
      doc.text(String(subtitle), 105, 36, { align: 'center' });
    }

    return doc;
  }

  function addSummaryColumns(doc, leftRows, rightRows, startY) {
    const y = startY || 45;
    const left = leftRows || [];
    const right = rightRows || [];

    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);

    left.forEach((row, index) => {
      doc.text(row, 20, y + (index * 7));
    });

    right.forEach((row, index) => {
      doc.text(row, 110, y + (index * 7));
    });

    return y + Math.max(left.length, right.length) * 7;
  }

  function addDataTable(doc, config) {
    const tableConfig = Object.assign({
      startY: 80,
      theme: 'striped',
      headStyles: { fillColor: [59, 130, 246] },
      styles: { fontSize: 8 }
    }, config || {});

    doc.autoTable(tableConfig);
    return doc.lastAutoTable ? doc.lastAutoTable.finalY : tableConfig.startY;
  }

  function addStandardFooter(doc, text) {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(128, 128, 128);
      doc.text(text || 'Generated by Fire-Calc.com - For educational purposes only', 105, 290, { align: 'center' });
    }
  }

  global.PdfExportUtils = {
    createBrandedPdf,
    addSummaryColumns,
    addDataTable,
    addStandardFooter
  };
})(window);
